<mat-spinner *ngIf="!loaded" diameter="50"></mat-spinner>

<div class="save-header" *ngIf="loaded">
  <h2>License and insurance credentials</h2>
</div>

<div class="content" [class.hidden]="!loaded">
  <member-profile-credential-list *ngIf="user?.loaded"
    [user]="user"
    (receiveCredentials)="handleCredentialsChanged()">
  </member-profile-credential-list>

  <member-provider-network-list
    [user]="user"
    (isLoaded)="networkListLoaded = true">
  </member-provider-network-list>
</div>
